<template>
  <div class="modal fade" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="exportOrderModalLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="!showProgress"><span aria-hidden="true" @click="reset">&times;</span></button>
          <h4 class="modal-title" id="updateUserModalLabel">Export Order Csv</h4>
        </div>
        <form @submit.prevent="sendMail()">
          <div class="modal-body">

            <div class="form-group">
              <label>Email</label>
            <vue-tags-input
                v-model="email"
                :tags="mails"
                @tags-changed="newTags => mails = newTags"
                :autocomplete-items="autocompleteItems"
                :validation="validation"
                :placeholder="'Add Email'"
            />
          </div>
            <div class="form-group">
              <label>Subject</label>
              <input v-model="subject" type="text" required class="form-control" title="add subject" placeholder="Add Subject..."/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <loader class="d_flex" v-if="showProgress" :default-height="false"/>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" :disabled="showProgress" data-dismiss="modal" @click="reset">Close</button>
            <button type="submit" class="btn btn-primary" :disabled="mails.length === 0 || showProgress">Send Mail</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import {exportOrders} from "@/api/orders";
import ProgressBar from "@/components/utils/ProgressBar.vue";
import Loader from "@/components/utils/Loader.vue";
import moment from "moment";
export default {
  name: "ExportOrders",
  components: {Loader, VueTagsInput, ProgressBar},
  data () {
    return {
      progressPercent: 0,
      showProgress: false,
      email: "",
      subject: "",
      mails: [],
      autocompleteItems: [{
        text: 'Enter valid email format. Must contain domain!',
      }],
      validation: [{
        classes: 'avoid-item',
        rule: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        disableAdd: true,
      }],
    }
  },
  props: {
    filters : {
      type: String,
      default: ''
    }
  },
  methods: {
    async sendMail() {
      let emailsList = this.mails.map(email => email.text)
      let params = new FormData();
      this.setDefaultCreated()
      params.append("allRequestParam", this.filters);
      params.append("emails", emailsList);
      params.append("subject", this.subject);
      this.showProgress = true
      try {
        const {data} = await exportOrders(params)
        this.showProgress = false
        swal("Success", data.message, "success")
        this.reset()
        $("#exportModal").modal('hide');
      } catch (e) {
        this.showProgress = false
        this.showErrorMessage(e)
        this.reset()
        $("#exportModal").modal('hide');
      }

    },
    setDefaultCreated() {
      let jsonObject = JSON.parse(this.filters);
      let columns = jsonObject.columns;
      let search = columns[6].search;
      if (search.value === "") {
        let currentDate = moment();
        let startDate = currentDate.clone().subtract(3, 'months').format('YYYY-MM-DD');
        let endDate = currentDate.format('YYYY-MM-DD');
        this.$set(search, "value", startDate + ' <==> ' + endDate);
      }
      this.filters = JSON.stringify(jsonObject);
    },
    reset() {
      this.showProgress = false
      this.progressPercent = 0
      this.email = ""
      this.subject = ""
      this.mails = []
    }
  }
}
</script>


<style scoped>
.vue-tags-input {
  max-width: 100% !important;
  border: 1px solid #E8E9EA !important;
  border-radius: 1px;
}
.d_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style>
body {
  padding-right: 0px !important;
}
</style>